import { Input, type InputProps } from '@chakra-ui/react';
import { useMask } from '@react-input/mask';
import { forwardRef } from 'react';

const PhoneInput = forwardRef<HTMLInputElement, InputProps>(({ ...props }, _ref) => {
  const inputRef = useMask({
    mask: '(__) _____-____',
    replacement: {
      _: /\d/,
    },
  });

  return <Input {...props} ref={inputRef} type="tel" />;
});

export default PhoneInput;